import { flightReducer } from './reducers/flight.reducer';
import { commonReducer } from '@store/reducers/common.reducer';

export const rootReducers = { flight: flightReducer, common: commonReducer };
